var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "#9AACCF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38187 10.8158H13.3549C13.8721 10.8158 14.346 10.527 14.583 10.0673C14.8201 9.60773 14.7806 9.05401 14.4808 8.63265L9.01427 0.951495C8.63526 0.419099 8.02192 0.102661 7.36832 0.102661C6.71472 0.102661 6.10139 0.419 5.72237 0.951495L0.255982 8.63265C-0.0438739 9.05411 -0.0833545 9.60773 0.153727 10.0673C0.390709 10.527 0.864675 10.8158 1.38187 10.8158Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3549 13.9209H1.38187C0.864675 13.9209 0.390709 14.2097 0.153727 14.6695C-0.0833545 15.129 -0.0438739 15.6827 0.255982 16.1041L5.72247 23.7852C6.10149 24.3177 6.71482 24.6341 7.36842 24.6341C8.02202 24.6341 8.63536 24.3177 9.01437 23.7852L14.4809 16.1041C14.7807 15.6826 14.8202 15.129 14.5831 14.6695C14.346 14.2097 13.8721 13.9209 13.3549 13.9209Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.5c987fbc.svg";
export { ForwardRef as ReactComponent };